import { render, staticRenderFns } from "./animation-switch.vue?vue&type=template&id=2441d9c3&scoped=true&"
import script from "./animation-switch.vue?vue&type=script&lang=js&"
export * from "./animation-switch.vue?vue&type=script&lang=js&"
import style0 from "./animation-switch.vue?vue&type=style&index=0&id=2441d9c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441d9c3",
  null
  
)

export default component.exports